const CURRENT_LANGUAGE = navigator.language;
const CURRENT_CURRENCY = 'RUB';

export const floatFormat = (
    value: number | null | undefined,
    options: Intl.NumberFormatOptions = {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
    },
): string | undefined => {
    if (value === 0)
        return '0';

    if (!value)
        return undefined;

    return value.toLocaleString(undefined, options);
}

// Оставляет n знаков после запятой
// Правильно округляет числа (при отсутствии знаков после запятой, не добавляет нули)
// Разделитель - точка
// При n = 3, 50000.9232 = 50000.923, 50000.00009 = 50000
export const formatNumberWithDotDelimiter = (num: number, maximumFractionDigits: number = 3) => {
    if (!Number(num))
        return 0;
    return parseFloat((num).toFixed(maximumFractionDigits));
}

//Преобразует число в денежный формат для корректного отображения валюты,
//Принимает число и название валюты
export const convertNumberToCurrency = (value: number, currency: string = CURRENT_CURRENCY, language: string = CURRENT_LANGUAGE): string => {
    if (!value && value !== 0)
        return '-';

    return value.toLocaleString(language, { style: 'currency', currency });
}

/*
*   Приводит в формат 0 руб 00 коп
*/
export const formatMoney = (num: any, hideZeroKopeck: boolean = false): string | number => {
    if (num === 0)
        return '0 руб 00 коп';

    if (!num)
        return num;

    const el = num.toString().split('.');
    const kopeck = el[1]
        ? `${el[1]?.slice(0, 2)} коп`
        : hideZeroKopeck
            ? ''
            : '00 коп';

    return `${el[0]} руб ${kopeck}`
}